import { TradingOfferOperation } from 'types/TradingOfferOperation';

const getOperationReference = (operation: TradingOfferOperation | null): string => {
  if (!operation) return '';
  const year = new Date(operation.createdAt).getFullYear();
  const idSuffix = operation._id.slice(-6).toUpperCase();
  return `#OP-${year}-${idSuffix}`;
};

export default getOperationReference;
